module.exports = __webpack_public_path__ + "static/media/9.b40e9f03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/dessins_cafe/9.jpg
// module id = 604
// module chunks = 0